import styled from 'styled-components';

import { typography } from './../../../../styles/helpers';
import { reversedGemAnimation } from '@/modules/jackpot/components/JackpotGemsPack/styled';
import { device } from '@/styles/helpers';

export const ScWheelPage = styled.div`
  h1 {
    text-align: center;
    margin-bottom: 0;
    text-transform: uppercase;
    ${typography['headline1']}
    margin-bottom: 16px;

    @media (${device.mobile}) {
      font-size: 28px;
      line-height: 36px;
    }

    & + div {
      max-width: 800px;
      margin: 16px auto;
      text-align: center;
      font-size: 16px;
      line-height: 24px;

      p {
        margin-top: 0;
        color: ${({ theme }) => theme.whiteColor};
      }
    }
  }

  & .header-benefits {
    margin: 8px 0 60px;
    @media (${device.mobile}) {
      margin-top: 0;
    }
  }
`;

export const ScWheelHeader = styled.div`
  position: relative;
  margin-top: -96px;
  padding-top: 96px;
  overflow: hidden;

  @media (${device.mobile}) {
    padding-top: 84px;
    & + div {
      width: calc(100vw - (100vw - 100%));
      overflow-x: hidden;
    }
  }
  .content {
    position: relative;
    text-align: center;
    z-index: 5;
  }

  & > .time-clock {
    margin-bottom: 48px;
    display: flex;
    justify-content: center;
    @media (${device.mobile}) {
      margin-bottom: 16px;
    }
  }

  .description {
    width: 800px;
    max-width: 100%;
  }

  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    display: block;
    width: 100%;
    height: 24px;
    border-radius: 24px 24px 0 0;
    background-color: ${({ theme }) => theme.blackColor};
    z-index: 1;
  }
`;

export const ScWheelHeaderAssets = styled.div`
  display: flex;
  justify-content: center;

  & > img:not(.mobile) {
    position: absolute;
  }

  & > .bg {
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;
    z-index: -1;
  }

  & > .decor {
    animation: ${reversedGemAnimation} infinite ease-out;
    top: 25%;

    &.left {
      left: calc((100% - 492px) / 4);
      animation-duration: 7s;

      @media (${device.mobile}) {
        /* default state
        width: 160px;
        height: 160px;
        inset: auto -80px 290px auto; 
        */
        width: 120px;
        height: 120px;
        inset: auto -20px 260px auto;
      }
    }
    &.right {
      right: calc((100% - 492px) / 3);
      animation-duration: 5s;

      @media (${device.mobile}) {
        width: 112px;
        height: 112px;
        inset: auto auto 56% 8px;
      }
    }
  }

  & > .static {
    bottom: 0;
    &.left {
      left: 0;
    }
    &.right {
      right: 0;
    }

    &.mobile {
      margin-bottom: 24px;
    }
  }
`;

export const ScWheelContent = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 64px;
  padding: 0 0 24px;

  @media (${device.mobile}) {
    padding-top: 8px;
  }
`;
